
/* Pet Paradise — Free Shipping bar UPDATE (bar is already in cart-drawer.liquid) */
(function(){
  var THRESHOLD = 24900;
  function money(a){ var n = Math.round(a)/100; return '₪' + (n%1===0 ? n.toFixed(0) : n.toFixed(2)); }
  function update(){
    fetch('/cart.js', {credentials:'include'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var bar = document.querySelector('[data-pp-shipbar]');
        if (!bar) return;
        var total = cart.total_price || 0;
        var pct = Math.min(100, (total / THRESHOLD) * 100);
        var reached = total >= THRESHOLD;
        var text = bar.querySelector('[data-pp-shipbar-text]');
        var fill = bar.querySelector('[data-pp-shipbar-fill]');
        if (text) {
          text.innerHTML = reached
            ? '🎉 קיבלת משלוח חינם!'
            : 'עוד ' + money(THRESHOLD - total) + ' ותקבל <b>משלוח חינם</b>!';
        }
        if (fill) {
          fill.style.width = pct + '%';
          fill.classList.toggle('pp-shipbar__fill--full', reached);
        }
      })
      .catch(function(){});
  }
  document.addEventListener('cart:updated', update);
  document.addEventListener('cart:refresh', update);
  document.addEventListener('cart:change', update);
  document.addEventListener('theme:cart:change', update);
})();

/* PP flashy-close-fix start */

/* Enlarge Flashy popup's 17x17 close button to 44x44 with a soft white circle */
(function () {
  var STYLE = [
    '.fls-close-popup a.fls-close.fls-top-right {',
    '  width: 44px !important;',
    '  height: 44px !important;',
    '  padding: 10px !important;',
    '  box-sizing: border-box !important;',
    '  background: rgba(255,255,255,0.94) !important;',
    '  border-radius: 50% !important;',
    '  box-shadow: 0 2px 10px rgba(0,0,0,0.20) !important;',
    '  display: flex !important;',
    '  align-items: center !important;',
    '  justify-content: center !important;',
    '  z-index: 100000 !important;',
    '  transition: transform .15s ease, box-shadow .15s ease !important;',
    '  cursor: pointer !important;',
    '  position: relative !important;',
    '  top: -6px !important;',
    '  right: -6px !important;',
    '}',
    '.fls-close-popup a.fls-close.fls-top-right:hover {',
    '  transform: scale(1.08) !important;',
    '  box-shadow: 0 3px 14px rgba(0,0,0,0.30) !important;',
    '}',
    '.fls-close-popup a.fls-close.fls-top-right svg {',
    '  width: 22px !important;',
    '  height: 22px !important;',
    '  display: block !important;',
    '}',
    '.fls-close-popup a.fls-close.fls-top-right svg line {',
    '  stroke: #511e16 !important;',
    '  stroke-width: 2.4 !important;',
    '  stroke-linecap: round !important;',
    '}',
    '.fls-close-popup { overflow: visible !important; min-height: 50px !important; }'
  ].join('\n');

  function patch(fp) {
    if (!fp || !fp.shadowRoot || fp.__ppCloseFixed) return;
    fp.__ppCloseFixed = true;
    var s = document.createElement('style');
    s.setAttribute('data-pp', 'close-fix');
    s.textContent = STYLE;
    fp.shadowRoot.appendChild(s);
    function fixSvg() {
      var svgs = fp.shadowRoot.querySelectorAll('a.fls-close svg');
      svgs.forEach(function (svg) {
        if (!svg.getAttribute('viewBox')) svg.setAttribute('viewBox', '0 0 16 16');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      });
    }
    fixSvg();
    var mo = new MutationObserver(fixSvg);
    mo.observe(fp.shadowRoot, { childList: true, subtree: true });
  }

  var tries = 0;
  var iv = setInterval(function () {
    var fp = document.querySelector('flashy-popup');
    if (fp) { patch(fp); clearInterval(iv); return; }
    if (++tries > 120) clearInterval(iv);
  }, 500);

  var bodyMo = new MutationObserver(function () {
    var fp = document.querySelector('flashy-popup');
    if (fp) patch(fp);
  });
  if (document.body) bodyMo.observe(document.body, { childList: true, subtree: false });
})();

/* PP flashy-close-fix end */







/* PP return-trust-badges start */

/* Trust-badge row rendered right after the .product__submit__buttons container.
   3 short badges (return / fast ship / secure pay) with tick icons.
   The 'החזרה' badge links to /pages/returns-policy. */
(function () {
  var CHECK_SVG = '<svg viewBox="0 0 20 20" width="16" height="16" style="flex:0 0 16px;color:#16a34a" fill="currentColor" aria-hidden="true"><path d="M8.5 14.5l-4-4 1.4-1.4 2.6 2.6 5.6-5.6L15.5 7.5z"/></svg>';

  var BADGES_HTML =
    '<div class="pp-trust-badges" style="display:flex;gap:14px;flex-wrap:wrap;justify-content:center;margin:14px 0 4px;padding:12px 8px;background:#f8f9fa;border-radius:8px;border:1px solid #ececec;">' +
      '<a href="/pages/returns-policy" style="display:flex;align-items:center;gap:6px;font-size:13px;font-weight:600;color:#333;text-decoration:none;">' +
        CHECK_SVG + '<span>החזרה 14 יום</span>' +
      '</a>' +
      '<div style="display:flex;align-items:center;gap:6px;font-size:13px;font-weight:600;color:#333;">' +
        CHECK_SVG + '<span>משלוח מהיר עד הבית</span>' +
      '</div>' +
      '<div style="display:flex;align-items:center;gap:6px;font-size:13px;font-weight:600;color:#333;">' +
        CHECK_SVG + '<span>תשלום מאובטח</span>' +
      '</div>' +
    '</div>';

  function inject() {
    var btnContainers = document.querySelectorAll('.product__submit__buttons');
    btnContainers.forEach(function (c) {
      if (c.__ppTrust) return;
      c.__ppTrust = true;
      var wrap = document.createElement('div');
      wrap.innerHTML = BADGES_HTML;
      c.parentNode.insertBefore(wrap.firstChild, c.nextSibling);
    });
  }

  var tries = 0;
  var iv = setInterval(function () {
    inject();
    if (document.querySelector('.pp-trust-badges') || ++tries > 30) clearInterval(iv);
  }, 500);

  var mo = new MutationObserver(inject);
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();

/* PP return-trust-badges end */









/* PP israeli-payment-badges start */

/* Add Bit badge to Trustz payment-icons row.
   Bit is prepended FIRST — most-used payment method for Israeli buyers.
   Uses inline-SVG data URI — no external requests. Idempotent per container. */
(function () {
  var BIT_SRC = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBhcmlhLWxhYmVsPSJCaXQiPjxyZWN0IHg9IjAuNSIgeT0iOCIgd2lkdGg9IjQ3IiBoZWlnaHQ9IjMyIiByeD0iNCIgZmlsbD0iI2ZmZmZmZiIgc3Ryb2tlPSIjZTVlN2ViIiBzdHJva2Utd2lkdGg9IjAuNSIvPjxyZWN0IHg9IjEyIiB5PSIxOCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEyIiByeD0iMiIgZmlsbD0iIzAwNzlDMSIvPjx0ZXh0IHg9IjI0IiB5PSIyNyIgZm9udC1mYW1pbHk9IkhlbHZldGljYSxBcmlhbCxzYW5zLXNlcmlmIiBmb250LXdlaWdodD0iOTAwIiBmb250LXNpemU9IjkiIGZpbGw9IiNmZmZmZmYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGxldHRlci1zcGFjaW5nPSItMC4zIj5iaXQ8L3RleHQ+PC9zdmc+';

  function inject() {
    var containers = document.querySelectorAll('.trustz-payment-badge-content');
    containers.forEach(function (c) {
      if (c.__ppBitBadge) return;
      var iconWrap = c.querySelector('img') && c.querySelector('img').parentElement;
      if (!iconWrap) return;
      c.__ppBitBadge = true;

      var img = document.createElement('img');
      // Same 48x48 as neighbors — keeps them all on one line, same visual weight.
      img.setAttribute('style', 'width:48px;height:48px;vertical-align:middle');
      img.setAttribute('alt', 'Bit');
      img.setAttribute('src', BIT_SRC);
      img.setAttribute('data-pp-badge', 'Bit');
      iconWrap.insertBefore(img, iconWrap.firstChild);
    });
  }

  var tries = 0;
  var iv = setInterval(function () {
    inject();
    if (document.querySelector('[data-pp-badge="Bit"]') || ++tries > 40) clearInterval(iv);
  }, 500);

  var mo = new MutationObserver(inject);
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });
})();

/* PP israeli-payment-badges end */




